module.exports = __webpack_public_path__ + "img/clouds-bg-m.1dca40c1.png";